import { Menu, Transition } from '@headlessui/react';
import { Fragment, type FC, type PropsWithChildren } from 'react';
// import { Dropdown, Menu, MenuButton } from '@mui/base';
import Avatar, { type AvatarProps } from '@/components/Avatar/Avatar';
import Icon, { IconName } from '@/components/base/Icon';

type Props = {
  chevron?: boolean;
} & AvatarProps;

// TODO: consider receiving a list of items to render, instead of expose `AvatarMenuItems`
const AvatarDropdown: FC<PropsWithChildren<Props>> = ({ children, chevron = false, ...avatarProps }) => {
  return (
    <Menu as="div" className="relative isolate inline-block">
      <Menu.Button className="group flex items-center text-white">
        <Avatar {...avatarProps} />
        {chevron && (
          <Icon
            icon={IconName.ChevronDown}
            className="origin-center text-inherit transition-transform group-aria-expanded:rotate-180"
          />
        )}
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition duration-100 ease-out"
        enterFrom="scale-95 transform opacity-0"
        enterTo="scale-100 transform opacity-100"
        leave="transition duration-75 ease-in"
        leaveFrom="scale-100 transform opacity-100"
        leaveTo="scale-95 transform opacity-0"
      >
        <Menu.Items className="absolute right-0 mt-1 min-w-[135px] origin-top-right rounded-md bg-white shadow-sm">
          {children}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default AvatarDropdown;
